import ApiClient from './ApiClient'

export default class CountriesService {

  constructor() {
    this.apiClient = new ApiClient()
  }

  get() {
    return this.apiClient.create().get(`countries`)
  }

}